import React, { useEffect, useState, useRef } from "react";
import "./FakeLoadingBar.scss";

interface FakeLoadingBarProps {
    isActive: boolean;
    maxDuration?: number; // ms to reach 95%
}

export const FakeLoadingBar: React.FC<FakeLoadingBarProps> = ({
    isActive,
    maxDuration = 8000,
}) => {
    const [progress, setProgress] = useState(0);
    const [visible, setVisible] = useState(false);
    const timerRef = useRef<NodeJS.Timeout>();
    const startTimeRef = useRef<number>();

    useEffect(() => {
        if (isActive) {
            setVisible(true);
            setProgress(5); // start immediately at 5%
            startTimeRef.current = Date.now();

            timerRef.current = setInterval(() => {
                const elapsed = Date.now() - (startTimeRef.current || 0);
                const t = Math.min(elapsed / maxDuration, 1); // 0 → 1

                // Ease-out cubic curve: fast start, slow finish
                const eased = 1 - Math.pow(1 - t, 3);
                const target = 5 + eased * 90; // 5% → 95%

                setProgress(target);
            }, 100); // update 10 times per second
        } else {
            // Finish immediately
            setProgress(100);
            setTimeout(() => {
                setVisible(false);
                setProgress(0); // reset after hidden
            }, 300);
        }

        return () => {
            if (timerRef.current) clearInterval(timerRef.current);
        };
    }, [isActive, maxDuration]);

    return (
        <div className="fake-loading-bar-wrapper">
            {visible && (
                <div
                    className="fake-loading-bar"
                    style={{
                        width: `${progress}%`,
                        transition: "width 0.3s ease-out, opacity 0.3s ease-out",
                        opacity: visible ? 1 : 0,
                    }}
                />
            )}
        </div>
    );
};
